/*! tailwindcss v4.2.2 | MIT License | https://tailwindcss.com */
@layer components {
  .notification {
    border-radius: var(--radius-sm, 0.25rem);
    &:global(.ant-notification-notice-success) {
      background-color: var(--foundation-green-100);
      & :global(.ant-notification-notice-icon) {
        color: var(--foundation-green-600);
      }
    }
    &:global(.ant-notification-notice-info) {
      background-color: var(--foundation-blue-100);
      & :global(.ant-notification-notice-icon) {
        color: var(--foundation-blue-600);
      }
    }
    &:global(.ant-notification-notice-warning) {
      background-color: var(--foundation-yellow-100);
      & :global(.ant-notification-notice-icon) {
        color: var(--foundation-yellow-600);
      }
    }
    &:global(.ant-notification-notice-error) {
      background-color: var(--foundation-red-100);
      & :global(.ant-notification-notice-icon) {
        color: var(--foundation-red-500);
      }
    }
  }
}
